/* eslint-disable react-hooks/exhaustive-deps */
import {
  FormInput,
  FormLabel,
  FormTextarea,
  TitleLabel,
} from '@Components/Common/FormComponent';
import { Info } from '@Components/Common/Info';
import { useGlobalSettingStore } from '@Models/useGlobalSettingModel';
import {
  storeSelector,
  templateSelector,
  usePolicyContext,
} from '@Policy/store';
import {
  PolicyTypeEnum,
  COLLABORATION_POLICY_TYPE_IDS,
} from '@Policy/utils/constants';
import {
  Checkbox,
  Flex,
  Switch,
  Text,
  Popover,
  PopoverContent,
  PopoverTrigger,
  useColorMode,
  useColorStyle,
} from '@tonic-one/react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useWhyDidYouUpdate } from 'src/utils/hooks';
import { PolicyHolderTypeEnum } from '@Policy/utils/types';
export const GeneralStatus = ({
  skipScanJunkEmailFolderShow,
  mipEnableFeatureShow,
  rmsEnabledShow = false,
}: {
  skipScanJunkEmailFolderShow: boolean;
  mipEnableFeatureShow: boolean;
  rmsEnabledShow?: boolean;
}) => {
  const { t } = useTranslation();
  // get store from context
  const contextStore = usePolicyContext();

  // get store api
  //   const { setState, getState } = contextStore;

  // get store selector
  const contextSelector = storeSelector(contextStore);
  const policySelector = templateSelector(contextStore);
  // get state and action from store
  const policyRealtimeEnabled = policySelector((s) => s.policyRealtimeEnabled);
  const isSkipFolderEnabled = policySelector((s) => s.isSkipFolderEnabled);
  const setGeneralState = contextSelector((s) => s.setGeneralState);
  const policyRmsEnabled = policySelector((s) => s.policyRmsEnabled);
  const policyType = policySelector((s) => s.policyType);
  const policyHolderType = policySelector((s) => s.policyHolderType);
  const mipTooltipKey = React.useMemo(() => {
    const isCollaboration = COLLABORATION_POLICY_TYPE_IDS.includes(
      String(policyType)
    );
    if (policyHolderType === PolicyHolderTypeEnum.ATP) {
      return isCollaboration
        ? 'policy.text.enableMipFunctions.atp.collaboration.tooltip'
        : 'policy.text.enableMipFunctions.atp.tooltip';
    }
    return isCollaboration
      ? 'policy.text.enableMipFunctions.collaboration.tooltip'
      : 'policy.text.enableMipFunctions.tooltip';
  }, [policyType, policyHolderType]);
  // local state
  const handlePolicyRealtimeEnabledChange = React.useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      setGeneralState({
        policyRealtimeEnabled: e.target.checked ? 1 : 0,
      });
    },
    []
  );
  const handleIsSkipFolderEnabledChange = React.useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      setGeneralState({
        isSkipFolderEnabled: e.target.checked ? 1 : 0,
      });
    },
    []
  );
  const handlePilicyMipEnabledChange = React.useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      setGeneralState({
        policyRmsEnabled: e.target.checked ? 1 : 0,
      });
    },
    []
  );
  const handelPolicyRmsEnabledChange = React.useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      setGeneralState({
        policyRmsEnabled: e.target.checked ? 1 : 0,
      });
    },
    []
  );
  const [colorMode] = useColorMode();
  const [colorStyle] = useColorStyle({ colorMode });
  const iconColor = React.useMemo(() => colorStyle.color.secondary, []);
  useWhyDidYouUpdate('GeneralStatus', {
    policyRealtimeEnabled,
    isSkipFolderEnabled,
  });
  const { selectedOrgGlobalSetting } = useGlobalSettingStore();
  let policyRealtimeSupport = true;
  if (policyType === PolicyTypeEnum.GoogleDrive) {
    policyRealtimeSupport =
      !!selectedOrgGlobalSetting.googleDriveRealtimeScanSupport;
  }
  return (
    <Flex direction="column">
      <Flex mb="4x" mt="2x" alignItems="center">
        <Popover
          arrow={true}
          trigger="hover"
          placement="top"
          enterDelay={500}
          disabled={policyRealtimeSupport}
        >
          <PopoverTrigger>
            <Switch
              mr="1x"
              id="policyStatus"
              value={Number(!!policyRealtimeEnabled)}
              checked={!!policyRealtimeEnabled}
              onChange={handlePolicyRealtimeEnabledChange}
              disabled={!policyRealtimeSupport}
            />
          </PopoverTrigger>
          <PopoverContent
            maxWidth="600px"
            PopperProps={{
              usePortal: true,
            }}
          >
            <Text color={colorStyle.color.primary}>
              {t('policy.tooltip.googleNotRealtimeScan')}
            </Text>
          </PopoverContent>
        </Popover>
        <TitleLabel title={t(`policy.label.policyStatus`)} mr="2x" />
        <Info
          iconStyle={{ color: iconColor }}
          content={t('policy.tooltip.realtimeScan')}
        />
      </Flex>
      {skipScanJunkEmailFolderShow && (
        <Flex mb="4x">
          <Checkbox
            checked={!!isSkipFolderEnabled}
            onChange={handleIsSkipFolderEnabledChange}
          >
            <Text color={colorStyle.color.primary}>
              {t('policy.text.skipFolder')}
            </Text>
          </Checkbox>
        </Flex>
      )}
      {mipEnableFeatureShow && (
        <Flex mb="4x">
          <Checkbox
            checked={!!policyRmsEnabled}
            onChange={handlePilicyMipEnabledChange}
          >
            <Flex alignItems="center">
              <Text color={colorStyle.color.primary} mr={8}>
                {t('policy.text.enableMipFunctions')}
              </Text>
              <Info content={t(mipTooltipKey)} />
            </Flex>
          </Checkbox>
        </Flex>
      )}
      {rmsEnabledShow && (
        <Flex mb="4x">
          <Checkbox
            checked={!!isSkipFolderEnabled}
            onChange={handelPolicyRmsEnabledChange}
          >
            <Text color={colorStyle.color.primary}>
              {t('policy.text.skipFolder')}
            </Text>
          </Checkbox>
        </Flex>
      )}
    </Flex>
  );
};
export const GeneralPolicyInfo = () => {
  const { t } = useTranslation();
  // get store from context
  const contextStore = usePolicyContext();
  // get store selector
  const contextSelector = storeSelector(contextStore);
  const policySelector = templateSelector(contextStore);
  // get state and action from store
  const policyName = policySelector((s) => s.policyName);
  const policyDescription = policySelector((s) => s.policyDescription);
  const policyPriority = policySelector((s) => s.policyPriority);
  const setGeneralState = contextSelector((s) => s.setGeneralState);
  // local state
  const [colorMode] = useColorMode();
  const [colorStyle] = useColorStyle({ colorMode });
  const iconColor = React.useMemo(() => colorStyle.color.secondary, []);
  useWhyDidYouUpdate('GeneralPolicyInfo', {
    policyName,
    policyDescription,
    policyPriority,
  });
  return (
    <Flex direction="column">
      <Flex mt="22px" alignItems="flex-start">
        <FormLabel label={t('policy.label.policyName')} required />
        <FormInput
          placeholder={t('policy.placeholder.policyName')}
          required
          value={policyName}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            // setPolicyName(e.target.value);
            setGeneralState({ policyName: e.target.value });
          }}
        />
      </Flex>
      <Flex mt="23px" alignItems="flex-start">
        <FormLabel label={t('policy.label.policyDescription')} />
        <FormTextarea
          placeholder={t('policy.placeholder.policyDescription')}
          value={policyDescription}
          onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => {
            // setPolicyDescription(e.target.value);
            setGeneralState({ policyDescription: e.target.value });
          }}
        />
      </Flex>
      <Flex mt="23px" alignItems="flex-start">
        <FormLabel label={t('policy.label.policyPriority')} required />
        <Flex alignItems="center">
          <FormInput
            mr={8}
            placeholder={t('policy.placeholder.policyPriority')}
            required
            value={policyPriority}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              // setPolicyPriority(e.target.value);
              setGeneralState({
                policyPriority: Number.isNaN(Number(e.target.value))
                  ? 1
                  : Number(e.target.value),
              });
            }}
          />
          <Info
            iconStyle={{ color: iconColor }}
            content={t('policy.tooltip.priority')}
          />
        </Flex>
      </Flex>
    </Flex>
  );
};
